export const normalizeProgramSearchText = (value) => String(value || '')
  .toLocaleUpperCase('tr-TR')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/[^A-Z0-9]+/g, ' ')
  .trim();

export const getProgramType = (programName) => {
  const normalizedName = normalizeProgramSearchText(programName);
  if (normalizedName.includes('TEZSIZ')) return 'Tezsiz';
  if (normalizedName.includes('TEZLI')) return 'Tezli';
  return 'Diğer';
};

export const getProgramEducationLevel = (programName, educationTypeId) => {
  const educationTypeLabels = {
    1: 'Ön Lisans',
    2: 'Lisans',
    3: 'Yüksek Lisans',
  };
  if (educationTypeLabels[educationTypeId]) {
    return educationTypeLabels[educationTypeId];
  }

  const normalizedName = normalizeProgramSearchText(programName);
  if (/(^| )DR( |$)/.test(normalizedName) || normalizedName.includes('DOKTORA')) {
    return 'Doktora';
  }
  if (/(^| )YL( |$)/.test(normalizedName) || normalizedName.includes('YUKSEK LISANS')) {
    return 'Yüksek Lisans';
  }
  return 'Lisans';
};

export const filterAndSortPrograms = (programs, filters) => {
  const searchQuery = normalizeProgramSearchText(filters.searchQuery);
  const filteredPrograms = programs.filter((program) => {
    const searchableText = normalizeProgramSearchText(`${program.name} ${program.faculty_name}`);
    const matchesSearch = !searchQuery || searchableText.includes(searchQuery);
    const matchesFaculty = !filters.faculty || program.faculty_name === filters.faculty;
    const matchesProgramType = !filters.programType || getProgramType(program.name) === filters.programType;
    const matchesEducationLevel = !filters.educationLevel
      || getProgramEducationLevel(program.name, program.education_type_id) === filters.educationLevel;

    return matchesSearch && matchesFaculty && matchesProgramType && matchesEducationLevel;
  });

  return [...filteredPrograms].sort((first, second) => {
    const direction = filters.sortDirection === 'desc' ? -1 : 1;
    return direction * String(first.name || '').localeCompare(String(second.name || ''), 'tr', {
      sensitivity: 'base',
    });
  });
};
